const isValidDate = (date) => date && !isNaN(new Date(date).getTime());

const daysSince = (dateString) => {
  const today = new Date();
  const date = new Date(dateString);
  const diffTime = Math.abs(today - date);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const filterStudentsWithoutActivityInDays = (days, studentData) =>
  studentData.filter(
    (student) =>
      !isValidDate(student.launched_at) || daysSince(student.launched_at) > days
  );

export const filterStudentsBySearch = (students, searchTerm) =>
  students.filter(
    (student) =>
      student.name.toLowerCase().includes(searchTerm.toLowerCase() || '') ||
      student.email.toLowerCase().includes(searchTerm.toLowerCase() || '')
  );
